import { render } from "./NotificationMessage.vue?vue&type=template&id=30f0a054"
import script from "./NotificationMessage.vue?vue&type=script&lang=js"
export * from "./NotificationMessage.vue?vue&type=script&lang=js"

import "./NotificationMessage.vue?vue&type=style&index=0&id=30f0a054&lang=css"
script.render = render

export default script